const DOCTOR_BASE_URL = import.meta.env.VITE_DOCTOR_API_BASE_URL;

export const getDoctorAvailability = async (
  doctorId,
  startDate,
  endDate,
  startTime,
  endTime,
  isBooked
) => {
  try {
    let url = `${DOCTOR_BASE_URL}/doctors/${doctorId}/slots?start_date=${startDate}&end_date=${endDate}`;

   
    if (startTime && endTime) {
      url += `&start_time=${startTime}&end_time=${endTime}`;
    }

 
    if (isBooked !== undefined) {
      url += `&is_booked=${isBooked}`;
    }

    console.log("FINAL API URL:", url);

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Failed to fetch slots");
    }

    return await response.json();
  } catch (error) {
    console.error("Slots API error:", error);
    throw error;
  }
};